import { render, staticRenderFns } from "./TradesmanThumbList.vue?vue&type=template&id=32c7a8ac&scoped=true&"
import script from "./TradesmanThumbList.vue?vue&type=script&lang=js&"
export * from "./TradesmanThumbList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c7a8ac",
  null
  
)

export default component.exports